module.exports = "@media (min-width: 1700px) {\n    /deep/ body {\n      margin: 14px;\n    }\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/layout/layout.component.css
// module id = ./src/app/components/layout/layout.component.css
// module chunks = main